import { render, staticRenderFns } from "./DetailsMobile.vue?vue&type=template&id=5aa07cb8&"
import script from "./DetailsMobile.vue?vue&type=script&lang=js&"
export * from "./DetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports